import { render, staticRenderFns } from "./ProductModalsCard.vue?vue&type=template&id=73de04bd&scoped=true&"
import script from "./ProductModalsCard.vue?vue&type=script&lang=js&"
export * from "./ProductModalsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73de04bd",
  null
  
)

export default component.exports